module.exports = __webpack_public_path__ + "static/media/logo-with-text-white.5a12b376.svg";